import React from 'react';
import "./meeting_styles/meetingpage.css";

const MeetingPage = () => {
    const handleClickJoinMeeting = () => {
        
    }

    return (
        <>
            <div className='meetingpage_container'>
                <div className='meeting_option'>
                    <button className='meeting_btn' onClick={handleClickJoinMeeting}>Join in a meeting</button>
                    <button className='meeting_btn'>Schedule a meeting</button>
                </div>
                <dialog className="modal" id="modal">
                    <h2>An interesting title</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum esse nisi, laboriosam illum temporibus ipsam?</p>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque, quo.</p>
                    <button className="button close-button">close modal</button>
                    <form className="form" method="dialog">
                        <label>Your name <input type="text"/></label>
                        <label>Your email <input type="email"/></label>
                        <button className="button" type="submit">submit form</button>
                    </form>

                </dialog>
            </div>
        </>
    )
}

export default MeetingPage